<script setup lang="ts">
import axios from 'axios'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { PermissionOrganization, ProductionBatchQuery } from '@/generated/graphql'
import useAuthorization from '@/composables/useAuthorization'

const props = defineProps<{ query: ProductionBatchQuery }>()
const { t } = useI18n()
const { hasOrgAuthz } = useAuthorization()
const loading = ref(false)
const failed = ref(false)

const download = async () => {
  if (loading.value) return
  loading.value = true
  failed.value = false
  try {
    const { poNumberContains, serialNumberContains, completed } = props.query
    const response = await axios.get('/download/production-batches', {
      params: { poNumberContains, serialNumberContains, completed },
      responseType: 'blob',
    })
    const filename = response.headers['content-disposition']?.match(/filename="([^"]+)/)?.[1]
    const url = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.download = filename || 'production-batches.xlsx'
    document.body.appendChild(link)
    try {
      link.click()
    } finally {
      link.remove()
      window.setTimeout(() => URL.revokeObjectURL(url), 1000)
    }
  } catch {
    failed.value = true
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <v-btn
    v-if="hasOrgAuthz(PermissionOrganization.OrgProductionBatchRead)"
    :loading="loading"
    prepend-icon="download"
    @click="download"
  >
    {{ t('entity.productionBatch.exportExcel') }}
  </v-btn>
  <v-snackbar v-model="failed" color="error">
    {{ t('entity.productionBatch.exportFailed') }}
  </v-snackbar>
</template>
